
import { defineComponent } from "vue";
import { ContentType } from "../../../../domain/entities/content/content";

export default defineComponent({
  name: "ContentItem",
  props: {
    title: {
      type: String,
      required: true
    },
    type: {
      type: Number,
      required: true
    },
    length: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isReleased: {
      type: Boolean,
      default: false
    },
    isNew: {
      type: Boolean,
      default: false
    },
    isInCorrection: {
      type: Boolean,
      default: false
    },
    isBlocked: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      ContentType
    };
  }
});
